import {
  aCreateAutomation,
  anAutomation,
  mockCreateAutomationOperationMutation,
} from '__generated__';
import { mockAutomation } from 'mocks/queries/AutomationQueryOperation.mocks';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockCreateAutomationOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(50);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createAutomation: aCreateAutomation({
            data: anAutomation({
              ...mockAutomation,
            }),
          }),
        },
      });
    }
  ),
];
